// Angular
import { Component, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';

// NGRX
import { Store } from '@ngrx/store';

// OLCI
import { constants } from '../../../constants/constants';
import * as fromRoot from '../../../reducers';
import * as tracking from '../../../actions/tracking';

@Component({
    selector: 'app-biometrics-privacy',
    templateUrl: './modal-biometrics-privacy.component.html',
    styleUrls: ['./modal-biometrics-privacy.component.scss'],
    standalone: false
})
export class ModalBiometricsPrivacyComponent implements OnChanges {
	@Input() public layoutState: string;
	@Input() public bundle: any = null;

	public showMenu: boolean;
	public showBiometricsPrivacyModal: boolean;
	public showSecondaryContent: boolean;

	constructor(private readonly store: Store<fromRoot.AppState>, @Inject('UrlService') public urlService: any) {
		this.showBiometricsPrivacyModal = false;
		this.showSecondaryContent = false;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes['layoutState']) {
			const layoutState = changes['layoutState']?.currentValue;
			if (
				layoutState &&
				(layoutState.openedModalName === constants.MODAL.BIOMETRICS_PRIVACY1 ||
					layoutState.openedModalName === constants.MODAL.BIOMETRICS_PRIVACY2)
			) {
				this.showBiometricsPrivacyModal = true;
				if (layoutState.openedModalName === constants.MODAL.BIOMETRICS_PRIVACY1) {
					this.showSecondaryContent = false;
				} else {
					this.showSecondaryContent = true;
				}
			} else if (layoutState && layoutState.openedModalName === 'close') {
				this.showBiometricsPrivacyModal = false;
			}
		}
	}

	public closeModal(): void {
		if (!this.showBiometricsPrivacyModal) {
			return;
		}

		this.showBiometricsPrivacyModal = false;
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: biometrics privacy: user closed info dialog'));
	}

	public privacyPolicyUrl(): string {
		const url = this.urlService.privacyPolicy(document.location.host);
		return !url || url === '' ? '/resources/privacy-policy' : url;
	}

	public contentMessage(): string {
		if (!this.bundle) {
			return '';
		}

		return this.bundle['data.privacy.modal.content1'] +
			this.bundle['data.privacy.modal.content2'] +
			this.bundle['data.privacy.modal.content3'] +
			this.bundle['data.privacy.modal.content4'] +
			this.bundle['data.privacy.modal.content5'] +
			this.bundle['data.privacy.modal.content6'] +
			this.bundle['data.privacy.modal.content7'] +
			this.bundle['data.privacy.modal.content8'] +
			this.bundle['data.privacy.modal.content9'];

	}

	public secondModalContent(): string {
		if (!this.bundle) {
			return '';
		}

		return this.bundle['second.data.privacy.modal.content1'] + this.bundle['second.data.privacy.modal.content2'];
	}
}
